export default function getInitState() {
    return {
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "name",
                label: "Kedvezmény neve",
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "rate",
                label: "Kedvezmény mértéke",
                visibility: true,
                formType: "number",                                                                                                                                                
                formSize: 3,
                formVisible: true
            },
            {
                name: "isAmount",
                label: "Összegszerű ",
                visibility: true,
                formType: "checkbox",                                                                                                                                                
                formSize: 3,
                formVisible: true
            },
        ]
    }
}
